module.exports = __webpack_public_path__ + "static/media/x.7bfe4c70.svg";